import { Brands } from "@theme/config/theme.config";

const environmentTypes = {
  FGF: 'FGF',
  NIM: 'NIM'
}

export const getEnvironmentType = (brand: Brands) => {
  switch(brand) {
    case 'fgfParent':
    case 'defaultFallback':
      return environmentTypes.FGF;
    case 'nimbleParent':
      return environmentTypes.NIM;
    default:
      return environmentTypes.FGF;
  }
}

